/*
  Contixo slideshow behavior (loaded from layout/theme.liquid).
  - With a mouse, the slideshow pauses only while the pointer is over the progress row at the
    bottom of the slide. Leaving the row resumes the countdown where it stopped (no extra time).
  - Touch screens never pause, since swiping back is easy there.
  The white fill on the progress row (contixo-modern.css) freezes and resumes in step with this timer.
*/
(function () {
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  customElements.whenDefined('slideshow-component').then(function () {
    document.querySelectorAll('slideshow-component').forEach(function (slideshow) {
      var slider = slideshow.querySelector('.slideshow');
      var controls = slideshow.querySelector('.slideshow__controls');
      if (!slider || !controls || slider.getAttribute('data-autoplay') !== 'true') return;

      var speed = (parseFloat(slider.getAttribute('data-speed')) || 5) * 1000;
      var remaining = speed;      // time left on the current slide
      var startedAt = Date.now(); // when the countdown last started or resumed
      var paused = false;

      // A new slide is showing (autoplay or a click on the row): start a fresh countdown.
      slideshow.addEventListener('slideChanged', function () {
        remaining = speed;
        startedAt = Date.now();
        if (!paused) slideshow.play();
      });

      // Stop Dawn's own pause-on-hover: everywhere on touch screens, and outside the row with a mouse.
      slideshow.addEventListener('mouseover', function (event) {
        if (!canHover || !controls.contains(event.target)) event.stopPropagation();
      }, true);

      // Dawn restarts a full countdown when the mouse leaves the slideshow; resuming is handled below instead.
      slideshow.addEventListener('mouseleave', function (event) {
        if (canHover && event.target === slideshow) event.stopImmediatePropagation();
      }, true);

      if (!canHover) return;

      controls.addEventListener('mouseenter', function () {
        if (paused) return;
        paused = true;
        remaining = Math.max(0, remaining - (Date.now() - startedAt));
        slideshow.pause();
      });

      controls.addEventListener('mouseleave', function () {
        if (!paused) return;
        paused = false;
        startedAt = Date.now();
        clearInterval(slideshow.autoplay);
        clearTimeout(slideshow.autoplay);
        // Finish only the time that was left, then move on. The slideChanged handler restarts the regular rhythm.
        slideshow.autoplay = setTimeout(function () {
          slideshow.autoRotateSlides();
        }, remaining);
      });

      // Line the timer up with the fill animation from the start.
      slideshow.play();
      startedAt = Date.now();
    });
  });
})();
